/**
 * Observes if an element is visible in the viewport. Once it is visible, the listener is removed
 * */
export function observeOnce(selector, fn, options) {
  var elems = [].slice.call(document.querySelectorAll(selector));
  var observer = new IntersectionObserver((entries, observer) => {
    for (var i = 0; i < entries.length; i++) {
      var entry = entries[i];
      if (entry.isIntersecting) {
        var elem = entry.target;
        fn(elem, observer);
        observer.unobserve(elem);
      }
    }
  }, options);
  elems.forEach(elem => {
    observer.observe(elem);
  });
}